import React from 'react'
import '../Styles/Section1.css'
import "slick-carousel/slick/slick.css"; 
import "slick-carousel/slick/slick-theme.css";
import Slider from 'react-slick';
import 'animate.css'

const Prevbtn = (props)=>{
    const { className, onClick } = props;
    return (
      <div className={className} onClick={onClick}>
        <i className="fa-solid fa-chevron-left prevbtn"></i>
      </div>
    )
}
   
const Nextbtn = (props)=>{
    const { className, onClick } = props;
    return (
      <div className={className} onClick={onClick}>
        <i className="fa-solid fa-chevron-right nextbtn"></i>
      </div>
    )
}

var settings = {
    autoplay : true,
    autoplaySpeed : 4000,
    initialSlide : 0,
    dots : true,
    infinite : true,
    dotsClass : 'slick-dots dots',
    prevArrow : <Prevbtn/>,
    nextArrow : <Nextbtn/>
}

export default function Section1() {

  return (
    <div className='section1'>
        <Slider { ...settings }>
          <div className="h1 h">
          </div>
          <div className="h2 h">
          </div>
          <div className="h3 h">
          </div>
          <div className="h4 h">
          </div>
          <div className="h5 h">
          </div>
          <div className="h6 h">
          </div>
        </Slider>
    </div>
  )
}
